export default function({ store }) {
  store.commit('IS_PAGE_LOADED', false)
}
